var React = require('react');

function Igloo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 384v96H192v-96a96 96 0 0 1 192 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 33.9a282 282 0 0 0-32-1.9A287.48 287.48 0 0 0 48.6 160H320zM96 192H30.3A286.63 286.63 0 0 0 0 320h96zM352 39.4V160h175.4A287.83 287.83 0 0 0 352 39.4zM480 320h96a286.63 286.63 0 0 0-30.3-128H480zm-64 64v96h128a32 32 0 0 0 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448zM0 448a32 32 0 0 0 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0z","className":"fa-primary","key":2})]);
}

Igloo.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Igloo;

Igloo.default = Igloo;
